import { FC, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Button from 'components/ui/Button/Button';
import FormGroup from 'components/ui/FormGroup/FormGroup';
import FormGroupDatepicker from 'components/ui/FormGroupDatepicker/FormGroupDatepicker';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import ScreenshotSupport from '../../ScreenshotSupport';
import MaximizeModal from '../../MaximizeModal';
import { dateFormat } from 'utils/shared/utils';
import useDraggableModal from 'hooks/useDraggableModal';

interface MoSpecialBabyNameProps {
  onClose: () => void;
  onSubmit: (model: any) => void;
}

const MoSpecialBabyName: FC<MoSpecialBabyNameProps> = ({ onClose, ...props }) => {
  const [t] = useTranslation();
  const modalOverlayRef = useRef<HTMLDivElement>(null);
  const { modalRef, modalStyle, dragHandleProps, isDragging } = useDraggableModal(true);
  const [model, setModel] = useState({
    fullName: '',
    dob: new Date(),
  });

  const onSubmit = async () => {
    props.onSubmit({
      fullName: model.fullName,
      dob: dateFormat(model.dob, 'dd-MM-yyyy'),
    });
    onClose();
  };

  return (
    <div
      className="modal-overlay modal-overlay-top modal-maximizable" style={{ direction: 'ltr' }}
      ref={modalOverlayRef}
      onClick={(e) => e.target === e.currentTarget && onClose()}
    >
      <div ref={modalRef} className={'modal modal-sm active'} style={modalStyle}>
        <div
          className={'modal-title draggable-modal-handle' + (isDragging ? ' dragging' : '')}
          {...dragHandleProps}
        >
          <h5 className="title">{t('mo.please_enter_info_about_baby')}</h5>
          <div data-no-drag="true">
            <ScreenshotSupport />
            <MaximizeModal modalOverlayRef={modalOverlayRef} />
            <FontAwesomeIcon icon={faTimes} onClick={() => onClose()} />
          </div>
        </div>
        <div className="modal-content text-sm modal-baby-name">
          <div className="flex-row">
            <div className="title col-12"></div>
            <FormGroup
              className="col-12 col-md-6 mb-20"
              label={t('login.full_name')}
              value={model.fullName}
              onChange={(fullName) => setModel({ ...model, fullName })}
              movablePlaceholder={t('login.full_name')}
            />
            <FormGroupDatepicker
              className="col-12 col-md-6 mb-20"
              label={t('passenger.dob')}
              appendToBody
              value={model.dob}
              onChange={(dob) => setModel({ ...model, dob })}
              movablePlaceholder={t('passenger.dob')}
            />
          </div>
        </div>
        <div className="modal-footer">
          <Button title={t('close')} className="btn btn-default" onClick={() => onClose()} />
          <Button title={t('Submit')} className="btn btn-primary" onClick={onSubmit} />
        </div>
      </div>
    </div>
  );
};

export default MoSpecialBabyName;
